import styled from "@emotion/styled";

import { MDSTextVariant } from "@/mds";

export const AgentOpenTasksBadge = ({ openTasksCount }: { openTasksCount: number }) => (
  <StyledBadge>{formatLabel({ openTasksCount })}</StyledBadge>
);

const formatLabel = ({ openTasksCount }: { openTasksCount: number }) => {
  if (openTasksCount === 1) {
    return "1 open task";
  }

  return `${openTasksCount} open tasks`;
};

const StyledBadge = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  flex: 0 0 auto;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextXs]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 20px;
  white-space: nowrap;
`;
